import { Size, Scale, CreateElement, LogGroup } from "../../MyHelpers";
import { SlotSymbolSprite } from "../SlotSymbolSprite";
import { PayTable, PaytablePerSymbol } from "./Paytable";
import { MyCanvas } from "../MyCanvas";
import { SlotSymbol } from "../SlotSymbol";
import { SlotGameMessages } from "../SlotGameScreenMessages";
import { IPaytable } from "./IPayTable";
import { IPaytableData } from "./PayTableFactory";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { ImageResource } from "../../ResourceManager/ImageResource";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IPaytableParams } from "./IPayTableFactory";
import { Settings } from "../../Settings";
import { CanvasSprite } from "../Sprite/CanvasSprite";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { Resource } from "../../ResourceManager/Resource";
import { PixiSpriteResource } from "../../ResourceManager/PixiSpriteResource";
import { PixiSprite } from "../Sprite/PixiSprite";
import { IRandomInterval } from "../../Context/RandomInterval";
import { ISystemContext } from "../../Context/SystemContext";
import { SymbolsCollectionResources } from "../SpineSymbols/SymbolsCollection";
import { SymbolType } from "../../api";
export interface ICombination {
	Count: number;
	WinCredits: number;
}
export interface IGroupedSimplePaytableData extends IPaytableData {
	Templete: string;
	Groups: { [key: string]: IGroup };
	PaytableForBetCredits: number;
}

export interface IGroup {
	Name: string
	Pays: ICombination[];
	Symbols: string[];
}

interface WinsMap
{
	symbolType: SymbolType;
	groupName: string;
	payIndex: number;
	winElement: HTMLElement;
}

export class PayTable8Squares implements IPaytable {
	protected symbolSize: Size = new Size(Scale.W(300), Scale.H(250));

	//	protected NumerSymbols: number = null;

	protected paytable: IGroupedSimplePaytableData;
	// //USE FOR COUNT SYMBOLS IN OTHERS PAYTABLE
	protected NumerSymbols: number = null;
	protected NumberGroups: number = 0;
	protected NameGroups: string[];
	protected symbols: SlotSymbol[];


	protected view: HTMLElement = null;
	//protected symbolSpriteAnims: SlotSymbolSprite[]
	//protected canvas: MyCanvas[] = [];
	protected viewSize: Size;

	//protected cash: Map<number, Map<number, HTMLElement>> = new Map<number, Map<number, HTMLElement>>();

	protected winsToUpdate: WinsMap[] = [];


	protected nameGame : string;
	protected basepath : string;

	//Create title Sprite 
	protected titleSprite : HTMLElement  = null;
	protected resid : ResourceIdentifier ;
	protected logGroup: LogGroup = new LogGroup("PayTable8Squares"); 
	// protected titleStartTimer : IRandomInterval ;
	protected systemContext : ISystemContext;
	readonly symbolsCollection : Map<string,SymbolsCollectionResources> = null;
	constructor(paytable: IGroupedSimplePaytableData, paytableParams : IPaytableParams) {
		//super(paytable, symbolSpriteAnims, viewSize);
		//this.symbolSpriteAnims = symbolSpriteAnims;

		this.viewSize = paytableParams.viewSize;
		this.paytable = paytable;
		//this.symbolSpriteAnims = paytableParams.symbolSpriteAnims;
		this.nameGame = paytableParams?.initData?.Meta?.onlineParams?.original ?? paytableParams.nameGame;
		this.basepath = Settings.ResourcesFolder + "multigame/slot/" + this.nameGame + "/";
		this.resid = paytableParams.resid.Add("JackpotDisplayCaliente");
		this.systemContext = paytableParams.systemContext.CreateSubContext("paytable8Squares")	
		this.symbolsCollection = paytableParams.symbolsCollection;





		this.view = CreateElement("div", {
			classes: ["paytable"],
			//parentToAppend: this.view,
			style: {
				//position: "absolute",
				width: Scale.Wpx(1920),
				height: Scale.Hpx(1080),
				display: "flex",
				alignContent: "center",
				alignItems: "center",
				fontFamily: "NotoSansDisplay-Regular",


			}
		});

		

		this.symbols = paytableParams.symbols;
		this.NameGroups = ["TopLeft", "MiddleLeft", "BottomLeft", "TopCenter", "BottomCenter", "TopRight", "MiddleRight", "BottomRight"];
		// let formatJson =JSON.stringify(this.paytable);		
		// this.paytable =  JSON.parse(formatJson);

		// console.log("paytable backend")
		// console.log(this.paytable);

		// for (let index = 0; index < this.NameGroups.length; index++) {
		// 	console.log(this.paytable.Groups[this.NameGroups[index]]);

		// }



	}
	OnResize(): unknown {
		throw new Error("Method not implemented.");
	}
	Build(): void {
		throw new Error("Method not implemented.");
	}

	public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		resourceManager.AddGlobal(new ImageResource(this.basepath + "resources/PayTable8Squares-Left.png", ResourceIdentifier.Global.Add([this.nameGame, "paytable", "background-left"]).Scope()));
		resourceManager.AddGlobal(new ImageResource(this.basepath + "resources/PayTable8Squares-Right.png", ResourceIdentifier.Global.Add([this.nameGame, "paytable", "background-right"]).Scope()));
		resourceManager.AddGlobal(new ImageResource(this.basepath + "resources/PayTable8Squares-Center.png", ResourceIdentifier.Global.Add([this.nameGame, "paytable", "background-center"]).Scope()));
		resourceManager.AddGlobal(new ImageResource(this.basepath + "resources/title.png", ResourceIdentifier.Global.Add([this.nameGame, "paytableTitle"]).Scope()));
		// resourceManager.AddGlobal(new PixiSpriteResource(this.basepath + "resources/title_sprite2", ResourceIdentifier.Global.Add(this.nameGame).Add("titlePaytable"), true, this.logGroup.Add("titlePaytable"), true));
	}



	public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		this.BuildPaytable( resourceManager);
	}
	public BuildPaytable( resourceManager : IReadOnlyResourceManager): void {




		//Test Info 
		//for Disable some container only need put false in enbale option container

		//Paytable COntainer
		this.symbolSize = new Size(Scale.W(300), Scale.H(250));
		let PaytableSymbolsContainer = CreateElement("div", {
			classes: ["paytable-symbols-container"],
			parentToAppend: this.view,
			style: {
				display: "flex",
				flexDirection: "column",
				flexWrap: "wrap",
				justifyContent: "space-evenly",
				width: "100%",
				height: "100%",

			}
		});

		let GroupPerColumn = 0;
		let symbol_number = 0;
		let IndexGroup = 0

		//Create 3 columns 
		//put 3 Groups in column 1 and 3 
		//and  2 Groups in Column 2
		for (let column = 0; column < 3; column++) {
			let PaytableSymbolsContainerColumn = CreateElement("div", {
				classes: ["paytable-symbols-container-column-" + column],
				parentToAppend: PaytableSymbolsContainer,
				style: {
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					height: "100%",
					alignContent:"center",
					alignItems:"center",
					// gap: Scale.Ypx(0),
				}
			});

			//put 3 Groups in column 1 and 3 
			//and  2 Groups in Column 2
			if (column == 0 || column == 2) {

				GroupPerColumn = 3;
			}
			else {

				GroupPerColumn = 2;
				//Add title in mitle group 
				// let titleContainer = CreateElement("div", {
				// 	classes: ["paytable-title-container"],
				// 	parentToAppend: PaytableSymbolsContainerColumn,
				// 	id: "title-container",
				// 	style: {
				// 		//width: Scale.Wpx(384),
				// 		display: "flex",
				// 		flexDirection: "column",
				// 		flexWrap: "wrap",
				// 		//justifyContent: "space-evenly",
				// 		//padding: Scale.XYpx(5),
				// 		//width: Scale.W(600) + "px",

				// 		//margin: "auto",
				// 		backgroundColor: "rgba(0, 0, 0, 0)",
				// 		borderRadius: Scale.XYpx(25),
				// 		//flexGrow: Scale.XYpx(0),
				// 		//height: Scale.H(320) + "px",
				// 		//backgroundImage: resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add([this.nameGame, "paytableTitle", "background"]).Scope()).CssBackground(),
				// 		//borderRadius: Scale.XYpx(0),
				// 		//backgroundSize: "contain",
				// 		//backgroundRepeat: "no-repeat",
				// 		//backgroundPosition: "center",
				// 	}
				// });

				// this.titleSprite = new CanvasSprite({
				// 	sprite: resourceManager.Get<PixiSpriteResource>(ResourceIdentifier.Global.Add(this.nameGame).Add("titlePaytable")).sprite,
				// 	canvasSize: new Size(Scale.W(765), Scale.H(400))
				// });
				// this.titleSprite.View().style.position="absolute";
				// this.titleSprite.View().style.top= Scale.Ypx(0);
				// this.titleSprite.View().style.left= Scale.Xpx(-25);
				// this.titleSprite.ScaleNonUniform(1.1,1);
				// PaytableSymbolsContainerColumn.appendChild(this.titleSprite.View());
				//this.titleSprite.Start(true);
				//Create Some interval 
				// this.titleStartTimer = this.systemContext.TimingContext().CreateRandomInterval("titleStartTimer", 5000, 10000 , () => this.titleSprite.Start(false));
				this.titleSprite = resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add([this.nameGame, "paytableTitle"]).Scope()).img.cloneNode(true) as HTMLElement;
				this.titleSprite.style.width = Scale.Wpx(700);

				// this.titleSprite.style.position = "absolute";
				// this.titleSprite.style.top = "0px";//Scale.Ypx(-25);
				// this.titleSprite.style.left = Scale.Xpx(-25);
				// this.titleSprite.style.width = Scale.Wpx(765);
				// this.titleSprite.style.height = Scale.Hpx(400);
				PaytableSymbolsContainerColumn.appendChild(this.titleSprite);


				// PaytableSymbolsContainerColumn.style.justifyContent = "end";
			}
			//Create Groups

		


			for (let Group = 0; Group < GroupPerColumn; Group++) {

				let symbols: string[] = this.paytable.Groups[this.NameGroups[IndexGroup]]?.Symbols;
				
				if ((symbols?.length ?? 0) == 0)
				{
					// no symbols in this groups
					IndexGroup++;
					continue;
				}

				let SymbolContainer = CreateElement("div", {
					classes: ["paytable-symbol-container"],
					parentToAppend: PaytableSymbolsContainerColumn,
					id: this.NameGroups[IndexGroup],
					style: {
						//width: Scale.Wpx(384),
						display: "flex",
						flexDirection: "column",
						flexWrap: "wrap",
						//justifyContent: "space-evenly",
						padding: Scale.XYpx(5),
						width: Scale.W(590) + "px",

						margin : "auto",
						backgroundColor: "rgba(0, 0, 0, 0)",
						borderRadius: Scale.XYpx(25),
						//flexGrow: Scale.XYpx(0),
						height: Scale.H(340) + "px",
						//background : "white",
						//yo
						backgroundImage: resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add([this.nameGame, "paytable", "background-left"]).Scope()).CssBackground(),
						//borderRadius: Scale.XYpx(0),
						backgroundSize: "contain",
						backgroundRepeat: "no-repeat",
						backgroundPosition: "center",
						position:"relative",

					}
				});

				if (this.NameGroups[IndexGroup] == "TopCenter" || 
					this.NameGroups[IndexGroup] == "BottomCenter")
				{
					SymbolContainer.style.width = Scale.Hpx(700);
					SymbolContainer.style.height = Scale.Wpx(340);
					SymbolContainer.style.backgroundImage = resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add([this.nameGame, "paytable", "background-center"]).Scope()).CssBackground()
					SymbolContainer.style.margin = "1px auto";
					SymbolContainer.style.justifyContent = "end";

				}

			
				let imgContainer = CreateElement("div", {
					classes: ["img-container",],
					parentToAppend: SymbolContainer,
					style: {
						width: "60%",
						//padding: 20px,
						//height: "100%",
						//min-height: 175px,
						//position: "relative",
						//border: 1px solid red,
						display: "flex",
						flexDirection : "column",
						position : "relative",
						//top : Scale.Ypx(-8),
						//left : Scale.Xpx(-15),

						//margin: 0px 0px 30px 0px,					

					}
				});

				

				
				for (let index = 0; index < symbols.length; index++) {


					let symbol = CreateElement("div", {
						classes: ["symbol", "paytable-symbol-" + symbol_number.toString()],
						parentToAppend: imgContainer,
						style: {
							//width: "100%",
							//padding: 20px,
							//height: "100%",
							//min-height: 175px,
							//position: "relative",
							//border: 1px solid red,
							display: "flex",
							flexDirection : "column"

							//margin: 0px 0px 30px 0px,					

						}
					});

					let PaytableSymbolImage = CreateElement("div", {
						classes: ["paytable-symbol-image", "image"],
						parentToAppend: symbol,
						style: {
							//flexGrow: "0",
							//flexShrink: "0",
							//width: "25%",
							//height: "100%",
							//display: "flex",
							alignItems: "center",
							justifyContent: "center",
							//marginTop:"0px",
							//marginBottom: Scale.Ypx(5),
							//marginLeft: Scale.Xpx(7),
							//marginRight: Scale.Xpx(19),
							//width: 200px;
							//height: 200px;
							//border: 1px solid red;
							//fontSize: Scale.fhpx(50),
							//width : "auto",
							//height : "auto",
							position : "relative",
							margin :  "auto "+ Scale.fhpx(5),




						}
					});
					let NameGroup = this.NameGroups[IndexGroup];

					if (symbols.length == 1) {


						//symbol.style.position = "relative";							
						//symbol.style.left = "-73px";
						//symbol.style.top = "-34px";
						if ( this.paytable.Groups[this.NameGroups[IndexGroup]].Name == "TopCenter" || this.paytable.Groups[this.NameGroups[IndexGroup]].Name == "BottomCenter" ){
							this.symbolSize = new Size(Scale.W(450), Scale.H(350));
							imgContainer.style.left = Scale.Ypx(-27);
							imgContainer.style.top = Scale.Ypx(13);
		
						}
						else{
						imgContainer.style.top = Scale.Ypx(27);
						imgContainer.style.left = Scale.Ypx(-32);
						//imgContainer.style.left = Scale.Ypx(-64);
						
						this.symbolSize = new Size(Scale.W(380), Scale.H(280));
						}
					}

					else if (symbols.length == 2) {

					
						symbol.style.justifyContent = "center";
						symbol.style.position = "relative";	
						symbol.style.height = "20%";
						imgContainer.style.top = Scale.Ypx(45);
						imgContainer.style.left = Scale.Ypx(-15);
					
						this.symbolSize = new Size(Scale.W(320), Scale.H(320));
						if (index == 1) {
							//symbol.style.position = "relative";
							symbol.style.left = Scale.Xpx(50);
						}

					

					}

					//PaytableSymbolImage.innerText = PaytableTestData[IndexGroup].symbol[index].toString();
					symbol_number++;

					//let canvas: MyCanvas = new MyCanvas(this.symbolSize);
					//this.canvas.push(canvas);

					let imgHTML = this.symbolsCollection.get("Symbol_" + symbols[index]).imgResource.cloneNode(true) as HTMLSpanElement;
					imgHTML.style.width = this.symbolSize.Width + "px";
					imgHTML.style.height = this.symbolSize.Height + "px";

					PaytableSymbolImage.appendChild(imgHTML);


					//PaytableSymbolImage.appendChild(canvas.view);

				}



				let PaytableCombinations = CreateElement("div", {
					classes: ["paytable-combinations"],
					parentToAppend: SymbolContainer,
					style: {
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						//position: "absolute",
						//left: Scale.Xpx(274),
						//top: Scale.Ypx(27),
						fontFamily: "Arial",
						fontWeight: "normal",
						position: "absolute",
						//left : Scale.Xpx(-66),
						//yo
						//flexGrow: "1",
						//yo
						//width : "30%",
						//height : "97%",
						//margin: "auto",
						lineHeight: Scale.fhpx(66),
						//alignItems : "center",
						//yoo
						textAlign : "left",
						//alignSelf : "center"
						//yo
						right: Scale.Xpx(60),
						height:"100%",
						marginRight:Scale.Xpx(20),
						
					}
				});

				if(this.paytable.Groups[this.NameGroups[IndexGroup]].Name == "TopLeft"||this.paytable.Groups[this.NameGroups[IndexGroup]].Name=="MiddleLeft"||this.paytable.Groups[this.NameGroups[IndexGroup]].Name=="BottomLeft"){
					PaytableCombinations.style.right = Scale.Xpx(30);
					PaytableCombinations.style.marginRight= Scale.Xpx(20);
				}

				if ( this.paytable.Groups[this.NameGroups[IndexGroup]].Name == "TopRight" || this.paytable.Groups[this.NameGroups[IndexGroup]].Name == "MiddleRight" || this.paytable.Groups[this.NameGroups[IndexGroup]].Name == "BottomRight"){
					SymbolContainer.style.flexDirection = "row-reverse";
					//yo
					//PaytableCombinations.style.alignItems = "center";
					PaytableCombinations.style.textAlign="right";
					PaytableCombinations.style.left = Scale.Xpx(50);
					PaytableCombinations.style.marginLeft= Scale.Xpx(20);
					//yo
					SymbolContainer.style.backgroundImage = resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add([this.nameGame, "paytable", "background-right"]).Scope()).CssBackground();	
				}


				//let combinations = this.paytable[symbol_number].Combinations;
				for (let indexPays = 0; indexPays < this.paytable.Groups[this.NameGroups[IndexGroup]].Pays.length; indexPays++) {
					//let r =        `<div class="paytable-combination paytable-combination-${ci}">`;

					let PaytableCombination = CreateElement("div", {
						classes: [ "paytable-combination-"+indexPays],
						parentToAppend: PaytableCombinations,
						style: {
							display: "flex",
							flexDirection: "row",
							fontWeight: "bold",
							alignItems: "center",
							verticalAlign: "middle",
							textShadow: " 0px 0px 5px black,0px 0px 10px black,0px 0px 15px black,0px 0px 40px black",
							flexShrink: "2",
							position: "relative",
							//right : Scale.Xpx(30),
						}
					});

				

					let PaytableOcurrence = CreateElement("div", {
						classes: ["paytable-occurence"],
						parentToAppend: PaytableCombination,
						style: {
							fontSize: Scale.fhpx(60),
							color: " #f49b42",
							//yo
							//width: Scale.Wpx(35),
							textAlign: "left",
						}
					});

					PaytableOcurrence.innerText = this.paytable.Groups[this.NameGroups[IndexGroup]].Pays[indexPays].Count.toString() + "x";

					// this is win, this updates
					let PaytableReward = CreateElement("div", {
						classes: ["paytable-reward"],
						parentToAppend: PaytableCombination,
						style: {
							fontSize: Scale.fhpx(50),
							color: " white",
							//marginTop: Scale.Ypx(5),
							//yo
							//position: "relative",
							//yo
							//left: Scale.Xpx(44),
							//flexGrow: Scale.fh(1).toString(),
							textAlign: "rigth",
							

						}
					});

					let symbolNames: string[] = this.paytable.Groups[this.NameGroups[IndexGroup]].Symbols;

					//let symbolName: string = symbolNames[s];
					let symbolType: SymbolType = this.symbols.find(symbol => symbol.ID == symbolNames[0]).SymbolType;
					this.winsToUpdate.push({
						symbolType: symbolType,
						groupName: this.NameGroups[IndexGroup],
						payIndex: indexPays,
						winElement: PaytableReward
					});
					
					PaytableReward.innerText = this.paytable.Groups[this.NameGroups[IndexGroup]].Pays[indexPays].WinCredits.toString();
					//console.log(this.paytable.Groups[this.NameGroups[IndexGroup]].Pays[indexPays].WinCredits.toString());
				}

				IndexGroup++;
			}




		}
		this.NumberGroups = IndexGroup;
		this.NumerSymbols = symbol_number;
			
		//console.log("Wins to update", this.winsToUpdate);
	}



	public SetBet(message: SlotGameMessages.BetChange) {
		let bet = message.bet;
		let totalBet = message.betTotalCredit;
		let factor = totalBet/this.paytable.PaytableForBetCredits;

		//for (let [symbolIndex, el] of this.winsToUpdate)
		for (let s = 0; s < this.winsToUpdate.length; s++)
		{
			let winToUpdate = this.winsToUpdate[s];
			// if scatter, calculate different

			let win: number = 0;
			if (winToUpdate.symbolType == "Scatter")
			{
				win = this.paytable.Groups[winToUpdate.groupName].Pays[winToUpdate.payIndex].WinCredits * totalBet;
			}
			else
			{
				win = this.paytable.Groups[winToUpdate.groupName].Pays[winToUpdate.payIndex].WinCredits * factor;
			}

			winToUpdate.winElement.innerText = win.toString();
			//console.log(win.toString());
		}
	}


	public Update(force: boolean = false): void {
		
		//if(this.titleSprite != null){
		// this.titleSprite?.Update();
		//}

	}
	public View(): HTMLElement {
		return this.view;
	}

	public StartAnim(){
		// this.titleStartTimer.Start();
	}

	public StopAnim(){
		// this.titleStartTimer.Stop();
	}


}

